export default __webpack_public_path__ + "static/media/default_single.b297e106.svg";